export default __webpack_public_path__ + "static/1-6b391750283229ab492c3687d8860223.png";